<template>
  <v-layout
      row
      :style="maxWidth"
  >
    <v-flex
        class="ml-3"
        :style="maxWidth"
    >
      <breadcrumbs
          :items="breadcrumbsItems"
      ></breadcrumbs>
      <v-card class="ma-3 col-sm-6" outlined>
        <v-card-title>Create Admin</v-card-title>
        <hr class="ma-1">
        <v-col>
          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
          >
            <v-autocomplete
                :items="roles"
                label="Role *"
                :rules="rolesRules"
                item-text="name"
                item-value="id"
                v-model="selectedRole"
            ></v-autocomplete>

            <v-autocomplete
                v-if="showGroups"
                :disabled="role === 'Outlet Admin'"
                :items="groups"
                label="Group *"
                :rules="[groupsRules]"
                item-text="name"
                item-value="id"
                v-model="selectedGroup"
            ></v-autocomplete>

            <v-autocomplete
                v-if="showOutlets"
                :disabled="role === 'Outlet Admin'"
                :items="outlets"
                label="Outlet *"
                :rules="[outletsRules]"
                item-text="name"
                item-value="id"
                v-model="selectedOutlet"
            ></v-autocomplete>

            <v-autocomplete
                v-if="showQueues"
                :items="queues"
                label="Queue *"
                :rules="[queuesRules]"
                item-text="name"
                item-value="id"
                v-model="selectedQueue"
            ></v-autocomplete>

            <v-text-field
                v-model="name"
                :rules="nameRules"
                label="Name *"
                autocomplete="off"
                required
            ></v-text-field>

            <v-text-field
                v-model="email"
                :rules="emailRules"
                label="E-mail *"
                required
                autocomplete="off"
            ></v-text-field>

            <vue-tel-input
                v-model="phone_no"
                name="phone"
                defaultCountry="SG"
                :onlyCountries="['SG', 'MY', 'CN', 'HK']"
                required
                :maxLen="15"
                enabledCountryCode
                validCharactersOnly
                :wrapperClasses="['mobile-input']"
                @validate="validateMobile"
                class="col ma-2"
                autocomplete="off"
            ></vue-tel-input>
            <v-row
                v-if="phone_no.length > 0 && !mobileIsValid"
                justify="center"
                style="margin-top: -18px; margin-bottom: 5px;"
            >
              <v-flex class="col-6 ml-1">
                <span style="font-size: 10px; color: red">Your mobile number is invalid</span>
              </v-flex>
            </v-row>

            <v-text-field
                v-model="password"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.required]"
                :type="showPassword ? 'text' : 'password'"
                label="Password"
                @click:append="showPassword = !showPassword"
                autocomplete="off"
            ></v-text-field>

            <v-btn
                :disabled="!valid"
                color="success"
                class="mr-4 font-weight-bold"
                @click="submit"
            >
              Save
            </v-btn>
          </v-form>
        </v-col>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'

export default {
  props: ['role', 'user'],
  data: () => ({
    valid: false,
    groups: [],
    outlets: [],
    queues: [],
    roles: [],
    rolesRules: [
      v => !!v || 'Role is required',
    ],
    selectedGroup: null,
    selectedOutlet: null,
    selectedQueue: null,
    selectedRole: null,
    name: null,
    nameRules: [
      v => !!v || 'Name is required',
    ],
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    password: '',
    showPassword: false,
    rules: {
      required: value => !!value || 'Required.',
    },
    phone_no: '',
    internationalPhone: '',
    mobileIsValid: false,
    countryCodes: [
      {'flag': '🇸🇬', 'country_code': 65, 'name': 'Singapore'},
      {'flag': '🇨🇳', 'country_code': 86, 'name': 'China'},
      {'flag': '🇭🇰', 'country_code': 852, 'name': 'Hong Kong SAR China'},
      {'flag': '🇲🇾', 'country_code': 60, 'name': 'Malaysia'},
    ],
    breadcrumbsItems: '',
    showGroups: true,
    showOutlets: false,
    showQueues: false,
  }),
  computed: {
    maxWidth() {
      return {
        maxWidth: window.outerWidth + 'px'
      }
    }
  },
  methods: {
    groupsRules() {
      if (this.showGroups && this.selectedGroup === null) {
        this.valid = false
        return "Group is required."
      } else {
        return true
      }
    },
    outletsRules() {
      if (this.showOutlets && this.selectedOutlet === null) {
        this.valid = false
        return "Outlet is required."
      } else {
        return true
      }
    },
    queuesRules() {
      if (this.showQueues && this.selectedQueue === null) {
        this.valid = false
        return "Queue is required."
      } else {
        return true
      }
    },
    validateMobile(phoneObject) {
      this.mobileIsValid = phoneObject.valid;
      this.country_code = phoneObject.country_code;
      if (phoneObject.valid && phoneObject.nationalNumber) {
          this.internationalPhone = phoneObject.country.dialCode + phoneObject.nationalNumber
      }
    },
    openMobile() {
      // Manually set using JS because CSS isn't applying the style
      const dropdownElementStyle = document.getElementsByClassName('vti__dropdown')[0].childNodes[2].style;
      if (dropdownElementStyle) {
        dropdownElementStyle.fontSize = "14px";
        dropdownElementStyle.width = "250px";
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        axios.post('/admin', {
          name: this.name,
          email: this.email,
          phone_no: this.internationalPhone,
          password: this.password,
          role_id: this.selectedRole,
          group_id: this.selectedGroup,
          outlet_id: this.selectedOutlet,
          queue_id: this.selectedQueue,
        }).then(response => {
          window.location.href = '/'
        });
      }
    },
  },
  watch: {
    selectedRole(newVal) {
      if (newVal === 1 || newVal === 6 || newVal === 7) {
        this.showGroups = false;
        this.showOutlets = false;
        this.showQueues = false;
      }
      if (newVal === 2) {
        this.showGroups = true;
        this.showOutlets = false;
        this.showQueues = false;
      }
      if (newVal === 4) {
        this.showGroups = true;
        this.showOutlets = true;
        this.showQueues = false;
      }
      if (newVal === 5) {
        this.showGroups = true;
        this.showOutlets = true;
        this.showQueues = true;
      }
    },
    selectedGroup(val) {
      if (val && this.showOutlets) {
        axios.get('/api/getGroupOutlets?gid=' + val).then(response => {
          this.outlets = response.data
        });
      }
    },
    selectedOutlet(val) {
      if (val && this.showQueues) {
        axios.get('/api/getOutletQueues?oid=' + val).then(response => {
          this.queues = response.data
        });
      }
    }
  },
  beforeMount() {
    // get outlets
    axios.get('/api/getGroups').then(response => {
      this.groups = response.data
    });
    if (this.role === 'Outlet Admin') {
      axios.get('/api/getOutletAdminRoles').then(response => {
        this.roles = response.data
      });
    } else {
      axios.get('/api/getAdminRoles').then(response => {
        this.roles = response.data
      });
    }

    if (this.role === 'Outlet Admin') {
      this.selectedGroup = this.user.group_id
      this.selectedOutlet = this.user.outlet_id
      axios.get('/api/getGroupOutlets?gid=' + this.user.group_id).then(response => {
        this.outlets = response.data
      });
      axios.get('/api/getOutletQueues?oid=' + this.user.outlet_id).then(response => {
        this.queues = response.data
      });
    }

    this.breadcrumbsItems = [
      {
        disabled: false,
        href: '/',
        link: true,
        text: 'Home',
      },
      {
        disabled: true,
        href: '#',
        link: true,
        text: 'Create Admin',
      },
    ];
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Admins/AdminCreate.vue